import { MAP_VERSIONS, WEBP_MAPS } from "@/game-eft/constants/map-data.mjs";
import keyInObject from "@/util/key-in-object.mjs";

/**
 * Determine if the current version of a map is a webp file. This is necessary due to some of our maps being rasterized rather than vectors
 * @param map - The map name
 * @param version - The version of the map
 * @return True if the map at the specified version is a webp
 */
export function isMapVersionWebp(map: string, version: string): boolean {
  return WEBP_MAPS?.[map]?.[version] ?? false;
}

/**
 * Get the latest map version for a given map.
 * @param map - The map name
 * @param defaultV1 - Whether to return the default version as v1. Will return an empty string if false.
 * @returns The map version
 */
export function getLatestMapVersion(map: string, defaultV1 = false) {
  return keyInObject(MAP_VERSIONS, map)
    ? MAP_VERSIONS[map]
    : `${defaultV1 ? "_v1" : ""}`;
}
